const phisherStatus = {
  yes: "Registered Phisher",
  no: "Unregistered",
};

export default phisherStatus;
